<template>
  <el-dialog :title="dialogTitle" :visible="visible" width="600px" :close-on-click-modal="false" class="page-dialog center-dialog" @close="handleClose">
    <div class="dialog-content">
      <el-form ref="formRef" :model="localFormData" :rules="formRules" label-width="100px" size="small">
        <el-form-item v-if="!isOnLineServiceC" label="客服名称" prop="name">
          <el-input v-model="localFormData.name" placeholder="请输入客服名称" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item v-if="!isOnLineServiceC" label="客服账号" prop="account">
          <el-input v-model="localFormData.account" placeholder="请输入客服账号" maxlength="50" show-word-limit />
        </el-form-item>
        <el-form-item label="配置地址" prop="config_url">
          <el-input v-model="localFormData.config_url" placeholder="请输入配置地址" maxlength="255" show-word-limit />
        </el-form-item>
        <el-form-item v-if="!isOnLineServiceC" label="图标" prop="icon_url">
          <SingleImageUpload v-model="localFormData.icon_url" :size="100" />
        </el-form-item>
        <el-form-item v-if="!isOnLineServiceC" label="状态" prop="status">
          <el-radio-group v-model="localFormData.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="!isOnLineServiceC" label="客服类型" prop="type_id">
          <el-select v-model="localFormData.type_id" placeholder="请选择客服类型" style="width: 100%">
            <el-option v-for="item in typeOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item v-if="!isOnLineServiceC" label="适用VIP等级" prop="vip_limit">
          <el-checkbox :value="localFormData.vip_limit.length === (vipOptions?.length || 0)" @change="handleAllVipChange">全部</el-checkbox>

          <el-checkbox-group v-model="localFormData.vip_limit">
            <!-- 全部选中 -->
            <el-checkbox v-for="item in vipOptions" :key="item.value" :label="item.value">
              {{ item.label }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item v-if="!isOnLineServiceC" label="排序" prop="sort">
          <el-input-number v-model="localFormData.sort" :min="0" :max="9999" controls-position="right" class="sort-input" />
        </el-form-item>
      </el-form>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取消</el-button>
      <el-button type="primary" :loading="loading" @click="handleConfirm">确认</el-button>
    </div>
  </el-dialog>
</template>

<script setup>
import { addCustomerService, saveCustomerService24, updateCustomerService } from '@/api/content/customerService'
import SingleImageUpload from '@/components/Upload/SingleImageUpload.vue'
import { useVipOptions } from '@/composables/useVipOptions'
import { computed, defineEmits, defineProps, getCurrentInstance, reactive, ref, watch } from 'vue'

const props = defineProps({
  visible: {
    type: Boolean,
    default: false,
  },
  dialogTitle: {
    type: String,
    default: '新增客服',
  },
  formData: {
    type: Object,
    default: () => ({}),
  },
  typeOptions: {
    type: Array,
    default: () => [],
  },
  isOnLineService: {
    type: Boolean,
    default: false,
  },
})
const isOnLineServiceC = computed(() => props.isOnLineService)

const emit = defineEmits(['update:visible', 'success'])

const { proxy } = getCurrentInstance()
const formRef = ref(null)
const loading = ref(false)
const { vipOptions } = useVipOptions()

const localFormData = reactive({
  id: null,
  name: '',
  account: '',
  config_url: '',
  icon_url: '',
  status: 1,
  type_id: null,
  vip_limit: [],
  sort: 0,
})

const formRules = {
  name: [{ required: true, message: '请输入客服名称', trigger: 'blur' }],
  type_id: [{ required: true, message: '请选择客服类型', trigger: 'change' }],
}

watch(
  () => [props.visible, props.formData],
  () => {
    if (props.visible) {
      const raw = props.formData || {}
      const vipLevels = raw.vip_limit
      const arr = Array.isArray(vipLevels) ? [...vipLevels] : []
      Object.assign(localFormData, {
        id: raw.id ?? null,
        name: raw.name ?? '',
        account: raw.account ?? '',
        config_url: raw.config_url ?? '',
        icon_url: raw.icon_url ?? '',
        status: raw.status !== undefined && raw.status !== null ? raw.status : 1,
        type_id: raw.type_id ?? null,
        vip_limit: arr,
        sort: raw.sort !== undefined && raw.sort !== null ? raw.sort : 0,
      })
    }
  },
  { immediate: true }
)

function handleAllVipChange(value) {
  if (value) {
    localFormData.vip_limit = (vipOptions.value || []).map(item => item.value)
  } else {
    localFormData.vip_limit = []
  }
}
function handleClose() {
  emit('update:visible', false)
}

function handleConfirm() {
  if (isOnLineServiceC.value) {
    const configUrl = (localFormData.config_url || '').trim()
    if (!configUrl) {
      proxy.$message.error('请输入配置地址')
      return
    }
    loading.value = true
    saveCustomerService24({ config_url: configUrl })
      .then(res => {
        if (res && res.code !== undefined && res.code !== 0) {
          throw new Error(res.message || '保存失败')
        }
        proxy.$message.success('保存成功')
        emit('success')
        handleClose()
      })
      .catch(error => {
        console.error('保存7*24小时客服配置失败', error)
        proxy.$message.error(error?.response?.data?.message || error.message || '保存配置失败')
      })
      .finally(() => {
        loading.value = false
      })
    return
  }
  formRef.value.validate(valid => {
    if (!valid) return
    loading.value = true
    const api = localFormData.id ? updateCustomerService : addCustomerService
    const payload = {
      name: localFormData.name,
      account: localFormData.account,
      config_url: localFormData.config_url,
      icon_url: localFormData.icon_url,
      status: localFormData.status,
      type_id: localFormData.type_id,
      vip_limit: localFormData.vip_limit,
      sort: localFormData.sort,
    }
    if (localFormData.id) payload.id = localFormData.id
    api(payload)
      .then(res => {
        if (res && res.code !== undefined && res.code !== 0) {
          throw new Error(res.message || '保存失败')
        }
        proxy.$message.success('保存成功')
        emit('success')
        handleClose()
      })
      .catch(error => {
        console.error('保存客服失败', error)
        proxy.$message.error(error?.response?.data?.message || error.message || '保存客服失败')
      })
      .finally(() => {
        loading.value = false
      })
  })
}
</script>

<style lang="scss" scoped>
.dialog-fixed-height {
  display: flex;
  align-items: center;
  justify-content: center;
}
.dialog-fixed-height ::v-deep .el-dialog {
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  margin: auto;
  margin-top: 5vh !important;
}
.dialog-fixed-height ::v-deep .el-dialog__header {
  flex-shrink: 0;
}
.dialog-fixed-height ::v-deep .el-dialog__body {
  flex: 1;
  min-height: 0;
  overflow-y: auto;
}
.dialog-fixed-height ::v-deep .el-dialog__footer {
  flex-shrink: 0;
}
.sort-input {
  width: 120px;
}
::v-deep .sort-input.el-input-number {
  width: 120px;
}
</style>
